// LP Slider Modal
$(function () {
  // product_modal-item をクリックしたときの処理
  $(".product_modal-item").on("click", function () {
    // クリックした product_modal-item の data-product_id の値を取得
    var target = $(this).data("product_id");
    console.log(target);
    var targetModal = $(".js-modal__main[data-product_id=" + target + "]");
    // js-modal__bg を表示する
    $(".js-modal__bg").fadeIn();
    targetModal.css('display', 'block').addClass('modal-slide-up').removeClass('modal-slide-down');
  })
  $('.js-modal__btn--close').on('click', function() {
    // クローズボタンに関連するモーダルを非表示にする
    // スライドダウンアニメーションを適用し、終了後にクラスを削除
    $(this).closest('.js-modal__main').addClass('modal-slide-down').removeClass('modal-slide-up');
    // js-modal__bg を非表示にする
    $(".js-modal__bg").fadeOut();
  });
  $(document).on('click', function(event) {
    if (!$(event.target).closest('.js-modal__main, .product_modal-item').length) {
      var openModals = $('.js-modal__main.modal-slide-up');
      // 開いているすべてのモーダルをスライドダウンし、js-modal__bg を非表示にする
      openModals.addClass('modal-slide-down').removeClass('modal-slide-up');
      $(".js-modal__bg").fadeOut();
    }
  });

})